import React, {useEffect} from 'react'
import Button from 'components/Button';
import Tr from 'translations/Translations';
import NoticeService from 'services/NoticeService';
import {withRouter} from "react-router";
import {connect} from 'react-redux'
import Loading from 'components/Loading';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import ValidationShema from "constants/ValidationShema";
import {DemandValidation} from "constants/DemandValidation";
import DemandValidationMessages from "components/DemandValidationMessages";

function NoticePage(
    {
        match,
        noticeLink,
        demandValidation
    }) {
    const section = demandValidation.find(x => x.section === DemandValidation.NOTICE);
    const editable = section ? section.editable : false;


    const demandId = match.params.id;
    const handleClick = () => window.location.href = noticeLink.link.url

    useEffect(() => {
        NoticeService.getLink(demandId);
        return () => NoticeService.clearResources(NoticeService.NOTICE_LINK_RESOURCE_ID);
    }, [demandId])

    const handleSubmit = () => NoticeService.save(demandId)

    if (!noticeLink) return <Loading/>
    return (
        <div style={{width: "100%"}}>
            <DemandValidationMessages section={section} editable={editable}/>
            <GridBlock justify="center" alignItems="center">
                <Form
                    onSubmit={handleSubmit}
                    id='mp_1_notice'
                    validationSchema={ValidationShema.any()}
                    afterSubmitFunc={() => {
                        if (isDemandModification()) {
                            ModificationService.isDemandChanged(demandId);
                        }
                    }}
                >
                    {(formikProps) => (
                        <Button onClick={handleClick}>{Tr("create_union_annoucement")}</Button>
                    )}
                </Form>
            </GridBlock>
        </div>
    )
}

export default connect((state) => ({
    noticeLink: state.resources.noticeLink,
    demandValidation: state.resources.demandValidation,
}), {})(withRouter(NoticePage));
